<template>
    <b-sidebar
        v-if="isSidebarOpen"
        v-model="isSidebarOpen"
        id="sidebar-right"
        right
        backdrop
        shadow
        width="109em"
        backdrop-variant="dark"
        ref="editItem"
        no-close-on-backdrop
        @change="closeSidePanelCallback()"
    >
        <template #title>
            <div>
                <strong id="sidebar-right___title__">Список операций</strong>
                <b-button @click="exportTable('motivationTable', 'motivation')" size="sm" class="ml-3 mb-1 mr-2">
                    Экспорт
                    <b-icon icon="cloud-download" aria-hidden="true" v-if="!isExportData"></b-icon>
                    <i class="fas fa-spinner fa-spin" v-else></i>
                </b-button>
            </div>
        </template>
        <div class="d-block">
            <b-table
                id="motivationTable"
                striped hover
                :sticky-header="computedWindowHeight"
                :items="items"
                :fields="fields"
                :busy="isTableBusy"
            >
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell()="data">
                    <template v-if="data.field.loading">
                        <template v-if="!data.value"><i class="fas fa-spinner fa-spin ml-1"></i></template>
                        <template v-else>{{ data.value }}</template>
                    </template>
                    <template v-else>
                        {{ data.value || "—" }}
                    </template>
                </template>
                <template #cell(order_id)="data">
                    <router-link
                        :to="{
                            query: {
                                order: data.value,
                            }
                        }"
                        target="_blank"
                    >
                        {{ data.value }}
                    </router-link>
                </template>
                <template #cell(type)="data">
                  {{ data.value === 'fine' ?  'Штраф' : 'Бонус'}}
                </template>
                <template #cell(sum)="data">
                    {{ formatNumbers(data.value) }}
                </template>
                <template #cell(edit)="data">
                    <template v-if="data.index != somethingChangingNow">
                        <tsoft-select-user
                            :id="`optional_sales_manager_user_id_${data.item.id}`"
                            :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||TO-manager||TO-head-manager||president`"
                            :needNullElement="false"
                            :additionalParameter="data.index"
                            :selected="data.item.manager_user_id"
                            @set="setAnotherManagerOfMotivation"
                        ></tsoft-select-user>
                    </template>
                    <template v-else>
                        Сохраняю <i class="fas fa-spinner fa-spin ml-1"></i>
                    </template>
                </template>
                <template v-slot:table-busy>
                    <div class="text-center text-success my-5">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
            </b-table>
        </div>
    </b-sidebar>
</template>
<script>
    import { API_GET_MOTIVATION } from "../../constants";
    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        excelExportHelpers
    } from '../../mixins'

    export default {
        props: {
            openMotivationList: { type: Boolean, required: true },                // Need to open motivationList
            motivationList: { type: Array, required: true },                      // Open List
            needEdition: { type: Boolean, default: false },                       // Need to edit motivation
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            excelExportHelpers
        ],
        data() {
            return {
                isTableBusy: false,
                computedWindowHeight: '',
                fields: [
                    {
                        key: 'index',
                        label: '№'
                    },
                    {
                        key: 'id',
                        label: 'ID',
                        stickyColumn: true,
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true,
                        'tdAttr': {
                            'data-t': 'n',
                        }
                    },
                    {
                        key: 'company.name',
                        label: 'Клиент',
                        stickyColumn: true,
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'company.inn',
                        label: 'ИНН',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true
                    },
                    {
                        key: 'order_id',
                        label: 'Идентификатор поставки',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true,
                        'tdAttr': {
                            'data-t': 'n',
                        }
                    },
                    {
                        key: 'type',
                        label: 'Тип мотивации',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true,
                    },
                    {
                        key: 'settings.name',
                        label: 'Наименование',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true,
                    },
                    {
                        key: 'sum',
                        label: 'Сумма',
                        sortable: true,
                        sortDirection: 'desc',
                        visible: true,
                        'tdAttr': {
                            'data-t': 'n',
                        }
                    }
                ],
                items: [],
                somethingChanged: false,
                somethingChangingNow: -1
            }
        },
        watch: {
            motivationList: {
                handler(motivationList) {
                    this.dataPrepareHandler(motivationList)
                },
                immediate: true
            }
        },
        created() {
            window.addEventListener("resize", this.handlerHeightWindow);
        },
        destroyed() {
            window.removeEventListener("resize", this.handlerHeightWindow);
        },
        mounted() {
            this.handlerHeightWindow()
        },
        methods: {
            dataPrepareHandler(motivationList) {
                this.isSidebarOpen = true
                this.isTableBusy = true
                this.items = motivationList
                if (this.needEdition) {
                    this.fields.push({
                        key: 'edit',
                        label: 'Изменить менеджера операции',
                        sortable: false,
                        sortDirection: 'desc',
                        visible: true,
                        thAttr: {
                            'data-exclude': 'true'
                        },
                        tdAttr: {
                            'data-exclude': 'true'
                        }
                    })
                }
                this.isSidebarOpen = true
                this.isTableBusy = false
            },
            handlerHeightWindow() {
                let deleteHeight = 115
                this.computedWindowHeight = `${window.top.innerHeight - deleteHeight}px`
            },
            closeSidePanelCallback() {
                this.closeMotivationList()
                this.isSidebarOpen = false
            },
            closeMotivationList() {
                this.$emit("closeMotivationList", this.somethingChanged)
            },
            setAnotherManagerOfMotivation(new_manager_user_id, index) {
                let id = this.items[index].id
                let old_manager_user_id = this.items[index].manager_user_id

                if (new_manager_user_id != old_manager_user_id) {
                    let dataForChange = {
                        manager_user_id: new_manager_user_id,
                        validated: 1
                    }

                    this.somethingChangingNow = index

                    api.call("put", `${API_GET_MOTIVATION}/${id}`, dataForChange).then(() => {
                        this.somethingChanged = true
                        this.items.splice(index, 1)
                        this.somethingChangingNow = -1
                    }).finally(() => {
                        this.makeToast('success', 'Успешно изменено!')
                    })
                }
            },
        }
    }
</script>
